module.exports = {
  "version": "0.33.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 420
// module chunks = 0